import { render } from "./AppCalendar.vue?vue&type=template&id=0155076a&ts=true"
import script from "./AppCalendar.vue?vue&type=script&lang=ts"
export * from "./AppCalendar.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__